<template>
  <div ref="inputFieldWrapper" :class="layoutView">
    <slot />
  </div>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue'
const inputFieldWrapper = ref(null)
const childCount = ref(0)
// Define the props
const props = defineProps({
  layoutMode: { default: false, type: Boolean },
  customClasses: { default: '', type: String },
})
let observer = null
const updateChildCount = () => {
  if (inputFieldWrapper.value) {
    childCount.value = inputFieldWrapper.value.children.length
  }
}
onMounted(() => {
  updateChildCount()
  observer = new MutationObserver(() => {
    updateChildCount()
  })

  if (inputFieldWrapper.value) {
    observer.observe(inputFieldWrapper.value, { childList: true })
  }
})
onUnmounted(() => {
  if (observer) {
    observer.disconnect()
  }
})
const layoutView = computed(() => {
  if (props.layoutMode) {
    return childCount.value > 1
      ? 'grid sm:grid-cols-2 xl:grid-cols-3 xl:gap-x-5 md:gap-x-4 gap-x-3'
      : 'grid grid-cols-1'
  }
  return childCount.value > 1
    ? `grid grid-cols-1 sm:grid-cols-2 gap-x-6 ${props.customClasses}`
    : `grid grid-cols-1 ${props.customClasses}`
})
</script>
